import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const subscriptionPlanApiConfig = {
  createSubscriptionPlan: {
    key: "createSubscriptionPlan",
    url: "/api/v1/subscription-plans",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["fetchSubscriptionPlans", "getSubscriptionPlan"],
      onSuccessMessage: "Subscription plan created successfully",
      onErrorMessage: "Failed to create subscription plan",
    },
  },

  getSubscriptionPlan: {
    key: "getSubscriptionPlan",
    url: (params) => `/api/v1/subscription-plans/${params?.id || params}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  fetchSubscriptionPlans: {
    key: "fetchSubscriptionPlans",
    url: "/api/v1/subscription-plans",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getActiveSubscriptionPlans: {
    key: "getActiveSubscriptionPlans",
    url: "/api/v1/subscription-plans/public",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  updateSubscriptionPlan: {
    key: "updateSubscriptionPlan",
    url: (data) => `/api/v1/subscription-plans/${data?.id || data}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["fetchSubscriptionPlans", "getSubscriptionPlan"],
      onSuccessMessage: "Subscription plan updated successfully",
      onErrorMessage: "Failed to update subscription plan",
    },
  },

  deleteSubscriptionPlan: {
    key: "deleteSubscriptionPlan",
    url: (data) => `/api/v1/subscription-plans/${data?.id || data}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["fetchSubscriptionPlans", "getSubscriptionPlan"],
      onSuccessMessage: "Subscription plan deleted successfully",
      onErrorMessage: "Failed to delete subscription plan",
    },
  },
};
